import React, { ReactElement, useEffect } from 'react';
import ChampFormulaire from '../../Common/ChampFormulaire';
import { Activite, HistoriqueLogs, ModeleHoraire, Produit } from '../../../../../common/src/entities';
import { useFormikContext } from 'formik';
import { useGetQuery } from '../../../Utils/api';
import FormulaireModificationEntite from '../Utils/FormulaireModificationEntite';
import { useParams } from 'react-router-dom';
import LogsLoader, { dateFormatter } from '../Utils/Log';
import { LABEL_COL } from '../constantes';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { TitreCarte } from '../../Common/TitreCarte';
import { MyPaper } from '../Utils/MyPaper';
import ChampMultipleActivite from '../Activites/ChampMultipleActivite';
import TableHoraireEntente from '../Ententes/Horaire/TableHoraireEntente';
import { ModeleHoraireActivite } from '../../../../../common/src/entities/modele-horaire-activite.entity';
import { ModeleHoraireProduit } from '../../../../../common/src/entities/modele-horaire-produit.entity';
import { PlageHoraire } from '../../../../../common/src/entities/plage-horaire.entity';
import ChampMultipleProduit from '../Produits/ChampsMultipleProduit';
import CheckboxFormulaireEtatEntite from '../../Common/CheckboxFormulaireEtatEntite';
import { EtatEntite } from '../../Common/EtatEntite';
import CheckboxFormulaire from '../../Common/CheckboxFormulaire';
import ChampMultipleModelesHoraireGlissable from './ChampMultipleModelesHoraireGlissable';

export function ChampsModeleHoraire(): ReactElement {
    const { values, setFieldValue } = useFormikContext<ModeleHoraire>();

    useEffect(() => {
        if (!values.horaire) {
            setFieldValue('horaire', {
                tableauPlageHoraire: {
                    headers: [],
                },
                plagesHoraires: [new PlageHoraire()],
            });
        }
        setFieldValue(
            'modeleHoraireActivite',
            values.modeleHoraireActivite?.length > 0 ? values.modeleHoraireActivite : [],
        );
        setFieldValue(
            'modeleHoraireProduit',
            values.modeleHoraireProduit?.length > 0 ? values.modeleHoraireProduit : [],
        );
        setFieldValue('activites', values.activites?.length > 0 ? values.activites : []);
        setFieldValue('produits', values.produits?.length > 0 ? values.produits : []);
    }, []);

    function ajouterModeleHoraireActivite() {
        setFieldValue('modeleHoraireActivite', [...values.modeleHoraireActivite, null]);
    }

    function ajouterModeleHoraireProduit() {
        setFieldValue('modeleHoraireProduit', [...values.modeleHoraireProduit, null]);
    }

    function supprimerModeleHoraireActivite(index: number) {
        const newModelesHoraireActivite = values.modeleHoraireActivite.filter((_, i) => i !== index);
        if (values.modeleHoraireActivite[index]) {
            setFieldValue(
                'activites',
                values.activites.filter((activite) => activite.id !== values.modeleHoraireActivite[index].activite.id),
            );
        }
        setFieldValue('modeleHoraireActivite', newModelesHoraireActivite);
    }

    function supprimerModeleHoraireProduit(index: number) {
        const newModelesHoraireProduit = values.modeleHoraireProduit.filter((_, i) => i !== index);
        if (values.modeleHoraireProduit[index]) {
            setFieldValue(
                'produits',
                values.produits.filter((produit) => produit.id !== values.modeleHoraireProduit[index].produit.id),
            );
        }
        setFieldValue('modeleHoraireProduit', newModelesHoraireProduit);
    }

    function initModeleHoraireActivite(index: number, activite: Activite) {
        const newModelesHoraireActivite: Partial<ModeleHoraireActivite>[] = [...values.modeleHoraireActivite];
        newModelesHoraireActivite[index] = {} as any;
        newModelesHoraireActivite[index].activite = activite;
        newModelesHoraireActivite[index].ordreAffichage = activite.modelesHorairesActivite.length + 1;
        setFieldValue('modeleHoraireActivite', newModelesHoraireActivite);
    }

    function initModeleHoraireProduit(index: number, produit: Produit) {
        const newModelesHoraireProduit: Partial<ModeleHoraireProduit>[] = [...values.modeleHoraireProduit];
        newModelesHoraireProduit[index] = {} as any;
        newModelesHoraireProduit[index].produit = produit;
        newModelesHoraireProduit[index].ordreAffichage = produit.modelesHorairesProduit.length + 1;
        setFieldValue('modeleHoraireProduit', newModelesHoraireProduit);
    }

    function changerHoraireParDefautActivite(checked: boolean, index: number) {
        if (checked) {
            setFieldValue('activites', [...values.activites, values.modeleHoraireActivite[index].activite]);
        } else {
            setFieldValue(
                'activites',
                values.activites.filter((activite) => activite.id !== values.modeleHoraireActivite[index].activite.id),
            );
        }
    }

    function changerHoraireParDefautProduit(checked: boolean, index: number) {
        if (checked) {
            setFieldValue('produits', [...values.produits, values.modeleHoraireProduit[index].produit]);
        } else {
            setFieldValue(
                'produits',
                values.produits.filter((produit) => produit.id !== values.modeleHoraireProduit[index].produit.id),
            );
        }
    }

    function EtatModeleHoraire(): JSX.Element {
        return (
            <EtatEntite>
                <CheckboxFormulaireEtatEntite id="actif" titre="Actif" />
            </EtatEntite>
        );
    }

    return (
        <div className="pb-5">
            {EtatModeleHoraire()}
            <MyPaper>
                <ChampFormulaire labelCol={LABEL_COL} id="name" titre="Nom" estPetit />
            </MyPaper>
            <TitreCarte>Activités</TitreCarte>
            <MyPaper>
                {values.modeleHoraireActivite &&
                    values.modeleHoraireActivite.map((modeleHoraireActivite, index) => (
                        <div key={index}>
                            <ChampMultipleActivite
                                id={`modeleHoraireActivite[${index}].activite`}
                                maxSize={1}
                                title="Activité"
                                labelCol={LABEL_COL}
                                avecUnBouton
                                onChange={(activite: Activite) => initModeleHoraireActivite(index, activite)}
                            />
                            <ChampMultipleModelesHoraireGlissable
                                labelCol={LABEL_COL}
                                id={`modeleHoraireActivite[${index}].activite.modelesHorairesActivite`}
                                horaireParDefautId={
                                    values.modeleHoraireActivite[index]?.activite.fk_id_horaire_par_defaut
                                }
                            />
                            {modeleHoraireActivite && modeleHoraireActivite.activite && (
                                <Row>
                                    <Col xs={LABEL_COL}>
                                        <CheckboxFormulaire
                                            id={'horaireParDefautActivite' + index}
                                            notifyChange={(checked) => changerHoraireParDefautActivite(checked, index)}
                                            titre={'Marquer comme horaire par défaut'}
                                            isChecked={values.activites.some(
                                                (activite) => activite.id === modeleHoraireActivite.activite.id,
                                            )}
                                        ></CheckboxFormulaire>
                                    </Col>
                                </Row>
                            )}
                            <Row className="mt-2">
                                <Col className="text-right">
                                    <Button
                                        size="sm"
                                        variant="danger"
                                        onClick={() => supprimerModeleHoraireActivite(index)}
                                    >
                                        Supprimer
                                    </Button>
                                </Col>
                            </Row>

                            <hr />
                        </div>
                    ))}

                <Button size="sm" variant="outline-primary" onClick={ajouterModeleHoraireActivite}>
                    Ajouter une activité
                </Button>
            </MyPaper>
            <TitreCarte>Produits</TitreCarte>
            <MyPaper>
                {values.modeleHoraireProduit &&
                    values.modeleHoraireProduit.map((modeleHoraireProduit, index) => (
                        <div key={index}>
                            <ChampMultipleProduit
                                id={`modeleHoraireProduit[${index}].produit`}
                                maxSize={1}
                                title="Produit"
                                labelCol={LABEL_COL}
                                avecUnBouton
                                onChange={(produit: Produit) => initModeleHoraireProduit(index, produit)}
                            />
                            <ChampMultipleModelesHoraireGlissable
                                labelCol={LABEL_COL}
                                id={`modeleHoraireProduit[${index}].produit.modelesHorairesProduit`}
                                horaireParDefautId={
                                    values.modeleHoraireProduit[index]?.produit.fk_id_horaire_par_defaut
                                }
                            />
                            {modeleHoraireProduit && modeleHoraireProduit.produit && (
                                <Row>
                                    <Col xs={LABEL_COL}>
                                        <CheckboxFormulaire
                                            id={'horaireParDefautProduit' + index}
                                            notifyChange={(checked) => changerHoraireParDefautProduit(checked, index)}
                                            titre={'Marquer comme horaire par défaut'}
                                            isChecked={values.produits.some(
                                                (produit) => produit.id === modeleHoraireProduit.produit.id,
                                            )}
                                        ></CheckboxFormulaire>
                                    </Col>
                                </Row>
                            )}

                            <Row className="mt-2">
                                <Col className="text-right">
                                    <Button
                                        size="sm"
                                        variant="danger"
                                        onClick={() => supprimerModeleHoraireProduit(index)}
                                    >
                                        Supprimer
                                    </Button>
                                </Col>
                            </Row>

                            <hr />
                        </div>
                    ))}
                <Button size="sm" variant="outline-primary" onClick={ajouterModeleHoraireProduit}>
                    Ajouter un produit
                </Button>
            </MyPaper>
            <TitreCarte>Horaire</TitreCarte>
            <MyPaper>{values.horaire && <TableHoraireEntente />}</MyPaper>
        </div>
    );
}

export default function DetailsModeleHoraire(): ReactElement {
    const { id } = useParams() as { id: string };
    const listLogs = useGetQuery<HistoriqueLogs[]>(`historique_logs/${id}/modeles_horaire`);
    function nettoyer(c: ModeleHoraire): void {
        if (c.modeleHoraireActivite[0] !== null) c.modeleHoraireActivite?.forEach((ae) => delete ae.activite['label']);
        if (c.modeleHoraireProduit[0] !== null) c.modeleHoraireProduit?.forEach((ae) => delete ae.produit['label']);
    }

    return (
        <div>
            <FormulaireModificationEntite
                id={+id}
                entite={ModeleHoraire}
                nettoyer={nettoyer}
                badges={(c: ModeleHoraire) => [
                    `Modèle d'horaire #${c.id}`,
                    `Dernière modification: ${
                        listLogs.data?.[listLogs.data.length - 1]?.date_modification
                            ? dateFormatter(listLogs.data?.[listLogs.data.length - 1]?.date_modification)
                            : 'Aucune modificiation'
                    } par ${listLogs.data?.[listLogs.data.length - 1]?.nom_usager ?? ''}`,
                ]}
            >
                <ChampsModeleHoraire />
            </FormulaireModificationEntite>
            <LogsLoader id={id} tableName={'modeles_horaire'} />
        </div>
    );
}
